<template>
  <div :class="getCss('progress-max')"  :style="mainStyle" >
    <!-- 弹窗容器 -->
    <div :class="getCss('container')"  :style="containerStyle">
     <table :class="getCss(`table-1`)" :style="varTabStyle">
      <!-- 头部样式 -->
      <thead :style="headerStyleGet">
        <tr>
          <th v-for="(item, index) in getcolumnConfigList"
            :style="getColumnStyle(index)" :key="index">
            {{ item.columnName }}
          </th>
        </tr>
      </thead>

      <!-- 主体样式 -->
      <tbody>
        <tr v-for="(item, index) in list" :key="index" :style="getTbodyStyle(index)">
          <td
            class="ellips"
            v-for="(_item, _index) in getcolumnConfigList"
            :key="_index" @click="emitOriginComponentEvent(_item, item)">
            <!-- 渲染头像 -->
            <template v-if="_item.componentType === 'image'">
              <p class="csu-public-ranking-text-ellips" :style="imageOuterStyle">
                <img
                  :style="imageStyle"
                  :src="textCop(_item, index)" />
              </p>
            </template>
            <!-- 当取用户名称字段(nickName)时，微信环境的用户信息含有html结构，需要解析html -->
            <template v-else>
              <p class="csu-public-ranking-text-ellips" v-if="isNickName" v-html="textCop(_item, index)"></p>
              <p class="csu-public-ranking-text-ellips" v-else>{{ textCop(_item, index) }}</p>
            </template>
          </td>
        </tr>
        <!-- 无数据 -->
        <tr  v-if ="list.length <=0 " :style="getNoDataStyle">
          <td :colspan="getcolumnConfigList.length">
            {{ getMsgTip }}
          </td>
        </tr>
        <!-- 补充空位 -->
        <tr
          v-for="(index) in getShowPageSize"
          :key="'add'+index"
          :style="getTbodyStyle(index)">
        </tr>
      </tbody>
      <!-- 尾部样式 -->
      <tfoot>
        <!-- 个人详情 -->
        <tr v-if ="userRankInfo.length > 0 && configurationData.showUserDetail" :style="getUserDetailStyle">
          <td
            class="ellips"
            v-for="(_item, _index) in getcolumnConfigList"
            :key="_index" @click="emitOriginComponentEvent(_item, 'myself')">
            <!-- 渲染头像 -->
            <template v-if="_item.componentType === 'image'">
              <p class="csu-public-ranking-text-ellips" :style="imageOuterStyle">
                <img
                  :style="imageStyle"
                  :src="textCop(_item, 0, 'myself')" />
              </p>
            </template>
            <!-- 当取用户名称字段(nickName)时，微信环境的用户信息含有html结构，需要解析html -->
            <template v-else>
              <p class="csu-public-ranking-text-ellips" v-if="isNickName" v-html="textCop(_item, 0, 'myself')"></p>
              <p class="csu-public-ranking-text-ellips" v-else>{{ textCop(_item, 0, 'myself') }}</p>
            </template>
          </td>
        </tr>

        <!-- 分页 -->
        <tr>
          <td  :colspan="getcolumnConfigList.length" :style="clearPadding">
            <p :class="getCss('page')"  :style="styles.footStyle">
              <a @click="pageClick(-1)" >{{ previousPage }}</a>
               <span>{{page.currentPage}}/{{page.totalPage}}</span>
              <a @click="pageClick(1)" >{{ nextPage }}</a>
            </p>
          </td>
        </tr>
      </tfoot>
     </table>
    </div>
  </div>
</template>

<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
// import mockDataT from './mock.js';

const INIT_DATA_TYPE_OF_ON_LOGIN = 1;// 登录刷新榜单
const INIT_DATA_TYPE_OF_ON_QUE_REFRESH = 2;// 资格刷新榜单
const INIT_DATA_TYPE_OF_ON_ROLE = 3;// 角色切换刷新榜单

export default {
  name: 'CPublicRanking',
  mixins: [componentBaseMixin],
  data() {
    return {
      timeout: null,
      cssPrefix: 'public-ranking-',
      res: [],
      list: [],
      msgTip: 0,
      userRankInfo: [],
      // 分页
      page: {
        currentPage: 1, // 当前页
        totalCount: 0,  // 总条数
        pageSize: 10,   // 一页条数
        totalPage: 0,   // 总共多少页
      },
    };
  },
  computed: {
    getcolumnConfigList() {
      return this.configurationData.columnConfigList || [];
    },
    // 根据配置的字段从后台映射数据
    textCop() {
      return (item, index, myself = '') => {
        let currentList = this.list; // 列表数据
        if (myself === 'myself') currentList = this.userRankInfo; // 个人详情数据
        let text = '';
        text = currentList?.[index]?.[item?.field] ?? '';
        const isAnalysis = 'partitionName,roleName,partition_name,role_name';
        const isRoleName = 'roleName,role_name';
        // 大区和角色需要解析
        if (isAnalysis.includes(item?.field)) {
          text = common.Base64.decode(this.list?.[index]?.[item?.field] ?? '');
        }
        // 当配置特殊字段 为button时，加载详情
        if (item.componentType === 'button') {
          text = item.text;
        }
        // 开启匿名模式
        if (this.configurationData.userAnonymous) {
          if (isRoleName.includes(item?.field)) {
            text = text[0] + text?.slice(1)?.replace(new RegExp('.', 'g'), '*');
          }
        }
        // 序号前缀
        if (item?.field.includes('rank')) {
          text = `${this.configurationData?.rankPrefix}${text}`;
        }
        return text;
      };
    },
    // 页面主元素动态样式
    mainStyle() {
      return {
        ...this.styles.base,
        ...this.styles.fontStyle,
      };
    },
    // 头部样式
    headerStyleGet() {
      return this.styles?.headerStyle || {};
    },
    // 清除padding
    clearPadding() {
      return {
        padding: 0,
      };
    },
    // 表格容器动态样式
    containerStyle() {
      const isBorder = this.getIsShowBorder ? 1 : 0;
      return `
          --padding-top: 0.2rem;
          --padding-bottom: 0.2rem;
          --th-color:${this.styles.headerStyle.color};
          --header-bcolor:${this.styles.headerStyle.backgroundColor};
          --border-width:${isBorder}px
        `;
    },
    // 表格动态样式
    varTabStyle() {
      return `
        --td-height: ${this.styles.tableStyle.height};
        --border-color: ${this?.styles?.tableStyle?.brdColor};
        --td-right: 0px;
      `;
    },
    // 计算需要填补的空位
    getShowPageSize() {
      if (this.list.length <= 0) {
        return 0;
      }
      return Number(this.configurationData.pageSize) - this.list.length;
    },
    // 表格没项宽度设置 未设置则按默认均分处理
    getColumnStyle() {
      return function (columnID) {
        return {
          width: `${this.getcolumnConfigList[columnID].columnWidth}rem`,
          fontWeight: this.styles.headerStyle.fontWeight,
        };
      };
    },
    // 没项列表背景颜色
    getTbodyStyle() {
      return function (index) {
        // 主体单列背景颜色
        if ((index + 1) % 2 === 1) {
          return `background-color: ${this.styles.mallStyle.SingleBackgroundColor};
          clipPath: inset(0rem 0rem 0rem 0rem round 5px);`;
        }
        // 主体双列背景颜色
        if ((index + 1) % 2 === 0) {
          return `background-color: ${this.styles.mallStyle.DoubleBackgroundColor};
          clipPath: inset(0rem 0rem 0rem 0rem round 5px);`;
        }
        return {};
      };
    },
    // 无数据样式
    getNoDataStyle() {
      return {
        color: this.styles.headerStyle.color,
        textAlign: 'center',
      };
    },
    // 个人详情样式
    getUserDetailStyle() {
      return {
        backgroundColor: this.styles.userDetailStyle.backgroundColor,
        color: this.styles.userDetailStyle.color,
      };
    },
    // 无数据显示文本
    getMsgTip() {
      return this.configurationData.msgTip;
    },
    // 上一页
    previousPage() {
      return this.configurationData.previousPage;
    },
    // 下一页
    nextPage() {
      return this.configurationData.nextPage;
    },
    // 是否展示表格边框
    getIsShowBorder() {
      return this.configurationData.isShowBorder;
    },
    isNickName() {
      return item => item?.field === 'nickName';
    },
    // 图片外层样式
    imageOuterStyle() {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: this.styles?.tableStyle?.height,
      };
    },
    // 图片样式
    imageStyle() {
      return {
        height: '90%',
        margin: '0 auto',
        borderRadius: '50%',
      };
    },
  },
  mounted() {
    this.initialize();
    this.$eventBus.$on('xxxxxxx', async (item) => {
      console.log('item===========', item);
    });
  },
  methods: {
    // 初始列表
    initialize() {
      console.log('[CPublicRanking] configurationData= 排行榜重构', this.configurationData);
      const { initDataType = INIT_DATA_TYPE_OF_ON_LOGIN } = this.configurationData;
      if (initDataType === INIT_DATA_TYPE_OF_ON_LOGIN) {
        this.$onLogined(() => {
          this.getData();
        });
      }
      if (initDataType === INIT_DATA_TYPE_OF_ON_QUE_REFRESH) {
        this.$onQuaRefreshed(() => {
          this.getData();
        });
      }
      if (initDataType === INIT_DATA_TYPE_OF_ON_ROLE) {
        this.$onRoleReady(() => {
          this.getData();
        });
      }

      try {
        this.initPage();
        if (this.$isInEditor) {
        // if (true) {
          this.initData();
        }
        this.getData();
      } catch (e) {
        console.log('初始化出错:', e);
      }
    },
    // 获取数据
    async getData() {
      // 当开启前端mock榜单数据 其余代码均不变，走这里的逻辑
      if (this.configurationData?.isOpenStatic) {
        this.statcData();
        return;
      }
      // 商业化设计模板, 获取排行数据
      if (!this.isLogin) {
        return;
      }
      this.page.pageSize = this.configurationData.pageSize;
      const response = await this.flowRequest({
        flowId: this.configurationData.getListFlowID,
        params: {
          role: this.roleInfo,
          data: JSON.stringify({
            pageNumber: this.page.currentPage,
            pageSize: Number(this.page.pageSize),
          }),
        },
      });
      // const response = mockDataT;
      const { ret, msg, data } = response;
      if (ret !== 0) {
        this.alert(msg);
        return;
      }
      this.list = [];
      const { list, total = list.length, myself } = data;
      if (!list) {
        return;
      }
      // 这个字段最新版已经没用了
      if (list.length <= 0) {
        this.msgTip = 1;
      }
      // const a = list.slice(0, 5);
      list.forEach((element) => {
        const currentInfo = this.setCurrentItem(element);
        this.list.push(currentInfo);
      });
      console.log('rank-list=', this.list);
      // 存在个人信息
      if (myself) {
        this.setUserRankInfo(myself);
      }

      this.page.totalPage = Math.ceil(total / this.configurationData.pageSize);
    },
    // 静态数据,不经过接口，通过配置读取
    statcData() {
      this.list = [];
      const mockList = [...this.configurationData?.staticRaningList];
      this.list = mockList.splice(
        (this.page?.currentPage - 1) * this.configurationData?.pageSize, this.configurationData?.pageSize
      );
      console.log('mock list page-size =', this.list, this.configurationData?.staticRaningList?.length / this.configurationData?.pageSize);
      this.page.totalPage = Math.ceil(
        this.configurationData?.staticRaningList?.length / this.configurationData?.pageSize
      );
    },
    // 个人详情
    setUserRankInfo(myself) {
      if (typeof myself !== '{}') {
        const currentInfo = this.setCurrentItem(myself);
        this.userRankInfo.push(currentInfo);
      }
    },

    /**
   * 设置当前项 如果存在attach 则扁平化里面的数据
   * currentInfo { Object }
   */
    setCurrentItem(currentInfo) {
      let newCurrentInfo = currentInfo;
      console.log('currentInfo', currentInfo);
      if (currentInfo?.attach) {
        const attach = JSON.parse(currentInfo?.attach || '{}');
        newCurrentInfo = {
          ...currentInfo,
          ...attach,
        };
      }

      // 前端配置数据存在 用后端固定itemId字段和前端配置的itemId匹配，将前端数据push到当前列表项，填充对应表格字段数据
      if (this.configurationData?.rankMetaList) {
        const { rankMetaFieldKey } = this.configurationData;
        console.log('rankMetaFieldKey', rankMetaFieldKey);
        const jsonList = JSON.parse(this.configurationData.rankMetaList);
        if (currentInfo?.[rankMetaFieldKey]) {
          jsonList.forEach((item) => {
            if (item?.[rankMetaFieldKey] === currentInfo?.[rankMetaFieldKey]) {
              newCurrentInfo = {
                ...newCurrentInfo,
                ...item,
              };
            }
          });
        }
      }
      console.log('newCurrentInfo', newCurrentInfo);
      return newCurrentInfo;
    },
    // 初始化page
    initPage() {
      const tdHeight = parseFloat(this.styles.tableStyle.height);
      let  bodyHeight  = parseFloat(this.styles.base.height);
      bodyHeight =  bodyHeight -  2 * tdHeight  - 0.5;

      let pageSize =  bodyHeight / tdHeight;
      pageSize = Math.floor(pageSize);
      if (pageSize < 1)  pageSize = 1;
      this.page.pageSize = pageSize;
    },
    // 上一页下一页点击事件-待开发
    pageClick(num) {
      if (this.page.currentPage <= 1 && num < 0) return;
      const cpage = this.page.currentPage + num;
      if (cpage > this.page.totalPage) return;
      this.page.currentPage =  cpage;
      this.getData();
    },
    // 生成数据
    initData() {
      const info = {};
      this.getcolumnConfigList.forEach((item) => {
        info[item.field] = '******';
      });
      this.list.push(info);
      console.log('this.list', this.list);
    },
    // 触发事件到其他组件
    emitOriginComponentEvent(key, data) {
      console.log('item', key, data);
      // 其他数据详情
      if (key.eventKey) {
        this.$eventBus.$emit(`${key.eventKey}`, data);
      }
      // 个人详情
      if (key.eventKey && data === 'myself') {
        this.$eventBus.$emit(`${key.eventKey}`, this.userRankInfo?.[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './styles.scss';

@font-face {
  font-family: 'D-DINExp-Bold';
  src: url('https://act.xinyue.qq.com/assets/fonts/DIN%20Next%C2%AE%20Pro%20Bold.ttf');
}
</style>
